import { useTranslations } from '@aikoa/i18n/react'
import { useState } from 'react'
import { TextInput, View } from 'react-native'
import { Label } from '~/components/typography/Content'
import { type ButtonSize, type ButtonVariant } from '~/components/ui/button'
import { InlineEditSheet } from '~/components/ui/InlineEditSheet'

type EditNotesSheetProps = {
  modalKey: string
  currentNotes?: string
  onSave: (notes: string) => void
  isPending?: boolean
  className?: string
  triggerClassName?: string
  triggerVariant?: ButtonVariant
  triggerSize?: ButtonSize
  triggerLabel?: string
  placeholder?: string
  title?: string
}

export function EditNotesSheet({
  modalKey,
  currentNotes,
  onSave,
  isPending = false,
  className,
  triggerClassName,
  triggerVariant = 'outline',
  triggerSize = 'default',
  triggerLabel,
  placeholder,
  title,
}: EditNotesSheetProps) {
  const { t } = useTranslations('notes')
  const [notes, setNotes] = useState<string>(currentNotes ?? '')

  const handleSave = () => {
    onSave(notes)
  }

  const handleCancel = () => {
    setNotes(currentNotes ?? '')
  }

  return (
    <InlineEditSheet
      modalKey={modalKey}
      title={title ?? t(($) => $.editSheet.title)}
      triggerLabel={triggerLabel ?? t(($) => $.editSheet.triggerLabel)}
      onSave={handleSave}
      onCancel={handleCancel}
      isSaving={isPending}
      isDisabled={isPending}
      className={className}
      triggerClassName={triggerClassName}
      triggerVariant={triggerVariant}
      triggerSize={triggerSize}>
      <View className="gap-2">
        <Label className="text-center">{t(($) => $.editSheet.label)}</Label>
        <TextInput
          multiline
          numberOfLines={10}
          value={notes}
          onChangeText={setNotes}
          placeholder={placeholder ?? t(($) => $.editSheet.placeholder)}
          className="min-h-[150px] rounded-xl border border-border bg-white px-4 py-3 text-base/normal text-foreground"
          textAlignVertical="top"
        />
      </View>
    </InlineEditSheet>
  )
}
